import { detect } from 'detect-browser'

export function isMobile() {
  return isIOS() || isAndroid()
}

export function isAndroid() {
  const browser = detect()

  return browser?.os?.toLowerCase().includes('android')
}

export function isIOS() {
  const browser = detect()

  return browser?.os?.toLowerCase().includes('ios')
}
